import { AIFunction } from '@/utils/const';

import { getBasePromptConfig } from './common';
import { ModelIdEnum } from './constants';

export const imageToImageModelConfig = [
  {
    modelName: 'Nano Banana 2',
    modelValue: ModelIdEnum.IMAGE_TO_IMAGE_Nano_Banana2,
    iconUrl: '/images/nano-banana.png',
    formConfig: [
      {
        type: 'file',
        label: 'merror.0.5.image',
        key: 'images',
        required: true,
        config: {
          type: 'image',
          accept: '.jpg,.png,.jpeg',
          tips: 'JPG-PNG-10MB-300',
          maxCount: 10,
          allowLibrarySelect: true,
          feature: AIFunction.Image2Image,
          rules: [
            {
              maxSize: 10 * 1024 * 1024,
              minResolution: '300*300',
              maxResolution: '5000*5000',
            },
          ],
        },
      },
      getBasePromptConfig(AIFunction.Image2Image),
      {
        type: 'AspectRatio',
        value: '9:16',
        label: '52e3e59f1db1469317e7aa55d9d670e4',
        key: 'aspect_ratio',
        config: {
          options: [
            { label: '21:9', value: '21:9' },
            { label: '9:16', value: '9:16' },
            { label: '16:9', value: '16:9' },
            { label: '4:5', value: '4:5' },
            { label: '5:4', value: '5:4' },
            { label: '4:3', value: '4:3' },
            { label: '3:4', value: '3:4' },
            { label: '3:2', value: '3:2' },
            { label: '2:3', value: '2:3' },
            { label: '1:1', value: '1:1' },
          ],
        },
      },
      {
        type: 'radio',
        value: '1k',
        label: 'merror.export.resolution',
        key: 'resolution',
        credit: true,
        config: {
          options: [
            { label: '1k', value: '1k' },
            { label: '2k', value: '2k' },
            { label: '4k', value: '4k' },
          ],
        },
      },
    ],
  },
  {
    modelName: 'Nano Banana Pro',
    modelValue: ModelIdEnum.IMAGE_TO_IMAGE_Nano_Banana_Pro,
    iconUrl: '/images/nano-banana.png',
    formConfig: [
      {
        type: 'file',
        label: 'merror.0.5.image',
        key: 'images',
        required: true,
        config: {
          type: 'image',
          accept: '.jpg,.png,.jpeg',
          tips: 'JPG-PNG-10MB-300',
          maxCount: 10,
          allowLibrarySelect: true,
          feature: AIFunction.Image2Image,
          rules: [
            {
              maxSize: 10 * 1024 * 1024,
              minResolution: '300*300',
              maxResolution: '5000*5000',
            },
          ],
        },
      },
      getBasePromptConfig(AIFunction.Image2Image),
      {
        type: 'AspectRatio',
        value: '9:16',
        label: '52e3e59f1db1469317e7aa55d9d670e4',
        key: 'aspect_ratio',
        config: {
          options: [
            { label: '21:9', value: '21:9' },
            { label: '9:16', value: '9:16' },
            { label: '16:9', value: '16:9' },
            { label: '4:5', value: '4:5' },
            { label: '5:4', value: '5:4' },
            { label: '4:3', value: '4:3' },
            { label: '3:4', value: '3:4' },
            { label: '3:2', value: '3:2' },
            { label: '2:3', value: '2:3' },
            { label: '1:1', value: '1:1' },
          ],
        },
      },
      {
        type: 'radio',
        value: '1k',
        label: 'merror.export.resolution',
        key: 'resolution',
        credit: true,
        config: {
          options: [
            { label: '1k', value: '1k' },
            { label: '2k', value: '2k' },
            { label: '4k', value: '4k' },
          ],
        },
      },
    ],
  },
  {
    modelName: 'Flux Kontext Pro',
    modelValue: ModelIdEnum.IMAGE_TO_IMAGE_Flux_Kontext_Pro,
    iconUrl: '/images/flux-kontext-pro.png',
    formConfig: [
      {
        type: 'file',
        label: 'merror.0.5.image',
        key: 'image',
        required: true,
        config: {
          type: 'image',
          accept: '.jpg,.png,.jpeg',
          tips: 'JPG-PNG-10MB-300',
          maxCount: 1,
          allowLibrarySelect: true,
          feature: AIFunction.Image2Image,
          multiple: false,
          rules: [
            {
              maxSize: 10 * 1024 * 1024,
              minResolution: '300*300',
              maxResolution: '5000*5000',
            },
          ],
        },
      },
      getBasePromptConfig(AIFunction.Image2Image),
      {
        type: 'AspectRatio',
        value: '9:16',
        label: '52e3e59f1db1469317e7aa55d9d670e4',
        key: 'aspect_ratio',
        config: {
          options: [
            { label: '21:9', value: '21:9' },
            { label: '9:21', value: '9:21' },
            { label: '9:16', value: '9:16' },
            { label: '16:9', value: '16:9' },
            { label: '4:3', value: '4:3' },
            { label: '3:4', value: '3:4' },
            { label: '3:2', value: '3:2' },
            { label: '2:3', value: '2:3' },
            { label: '1:1', value: '1:1' },
          ],
        },
      },
    ],
  },
];
